import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import FNOLHOWizard from './FNOLHOWizard';
import FNOLCriminalDamagePage from './pages/CriminalDamage/CriminalDamagePage';
import FNOLFireDamagePage from './pages/FireDamage/FireDamagePage';
import FNOLHOTypeOfIncidentPage from './pages/TypeOfIncident/TypeOfIncidentPage';
import FNOLWaterDamagePage from './pages/WaterDamage/WaterDamagePage';

setComponentMapOverrides(
    {
        FNOLHOWizard: { component: 'FNOLHOWizard' },
        FNOLHOTypeOfIncidentPage: { component: 'FNOLHOTypeOfIncidentPage' },
        FNOLFireDamagePage: { component: 'FNOLFireDamagePage' },
        FNOLWaterDamagePage: { component: 'FNOLWaterDamagePage' },
        FNOLCriminalDamagePage: { component: 'FNOLCriminalDamagePage' },
    },
    {
        FNOLHOWizard,
        FNOLHOTypeOfIncidentPage,
        FNOLFireDamagePage,
        FNOLWaterDamagePage,
        FNOLCriminalDamagePage,
    }
);

export { FNOLHOWizard as default };
